import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'redux-zero/react';

import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import OurVisionService from './our-vision.service.js';
import Seo from '../../infrastructure/seo.js';

import './our-vision.scss';

const scrollToTop = () => window.scrollTo({
	top: 0,
	behavior: 'smooth',
});

class OurVisionPage extends Component {
	static prefetchData = async language => OurVisionService.getPageData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		scrollToTop();
		if (!this.props.ourVisionPageData) {
			this.fetchData();
		} else {
			this.props.setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		scrollToTop();
		if (this.props.language.value !== prevProps.language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		this.props.setLoading(true);
		OurVisionPage.prefetchData(this.props.language.value)
			.then((data) => {
				this.props.setOurVision(data);
				this.props.setLoading(false);
			})
			.catch((error) => {
				this.props.setLoading(false);
				this.setState({
					hasError: true,
				});
				console.log(error);
			});
	}

	render() {
		const { ourVisionPageData, intl: { formatMessage }, addresses, phones, generalData } = this.props;
		const { hasError } = this.state;

		if (hasError || !ourVisionPageData) {
			return <NotImplemented title="Our Vision" />;
		}

		return (
			<section className="our-vision">
				<Seo
					title={formatMessage({ id: 'navigation.about.ourVision' })}
					description={(ourVisionPageData && ourVisionPageData.description) || formatMessage({ id: 'navigation.about.ourVision' })}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "AboutPage",
											"name": "${ourVisionPageData && ourVisionPageData.title}",
											"description": "${ourVisionPageData && ourVisionPageData.description}",
											"image": "${ourVisionPageData && `${process.env.REACT_APP_API_ENDPOINT}${ourVisionPageData.image.path}`}"
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.about.ourVision' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/about/our-vision"
												}
											]
										}
									]
								}`}
				/>
				<div className="container container-fluid">
					<div className="section intro row">
						<div className="col col-lg-4 col-md-4 col-sm-12 col-xs-12 title">
							{ourVisionPageData.title}
						</div>
						<div className="col col-lg-8 col-md-8 col-sm-12 col-xs-12 subtitle">
							{ourVisionPageData.description}
						</div>
					</div>
				</div>
				<div
					className="full-image"
					style={{
						backgroundImage:
							`url('${process.env.REACT_APP_API_ENDPOINT}/${ourVisionPageData.image.path}')`,
					}}
				/>
			</section>
		);
	}
}

const mapToProps = ({ language, ourVisionPageData, addresses, phones, generalData }) => ({
	language,
	ourVisionPageData,
	addresses,
	phones,
	generalData,
});
export default connect(
	mapToProps,
	actions,
)(injectIntl(OurVisionPage));

export { OurVisionPage };
